import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0612d4ad&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/mintPage.scss?vue&type=style&index=0&id=0612d4ad&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=0612d4ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612d4ad",
  null
  
)

export default component.exports